import * as React from 'react';
import { EDeviceType } from '../../types/device';
export var Context = /*#__PURE__*/React.createContext(EDeviceType.Desktop);